import { CategoryIcon } from "components/CategoryIcon";
import { useTracking } from "hooks/useTracking";
import { FunctionComponent } from "react";
import { CardImage } from "./CardImage";
import { CardMeta } from "./CardMeta";
import { CardMetaAccomodation } from "./CardMetaAccomodation";
import { CardMetaTour } from "./CardMetaTour";

const metaComponents: {
  [Key in Travelguide.Activity]?: Key extends "unterkunft"
    ? FunctionComponent<{ item: Travelguide.Accomodation }>
    : Key extends "touren"
    ? FunctionComponent<{ item: Travelguide.Tour }>
    : null;
} = {
  unterkunft: CardMetaAccomodation,
  touren: CardMetaTour,
  naturatlas: null,
};

type CardProps = {
  item: Travelguide.OOI;
};

export const Card = ({
  item,
  showText = true,
}: {
  item: Travelguide.OOI;
  showText?: boolean;
}) => {
  const slug = item.category.activity?.slug;
  const Meta = (
    slug && slug in metaComponents ? metaComponents[slug] : CardMeta
  ) as FunctionComponent<CardProps>;
  const { autoTrackingRef } = useTracking(item.id, true);
  return (
    <div
      ref={autoTrackingRef}
      className="flex flex-col gap-y-6 overflow-hidden bg-white text-primary md:shadow-md"
    >
      <a
        href={`/${item.category.activity?.slug}/${item.slugTitle}-${item.id}`}
        className="h-full flex flex-col gap-y-6"
      >
        <header className="relative flex flex-col gap-y-6">
          <div className="relative mb-[5%]">
            <CardImage item={item} />
            <CategoryIcon
              category={item.category}
              className="absolute w-3/12 max-w-[7rem] bottom-[-12.5%] right-[5%] md:right-[10%]"
            />
          </div>
          <h1 className="text-card-h1 px-8 font-bold">{item.title}</h1>
        </header>
        <main className="flex flex-col flex-1 gap-y-6 px-8 pb-6">
          {Meta && <Meta item={item} />}
          {showText && <p>{item.shortText}</p>}
        </main>
      </a>
    </div>
  );
};
